import { getAiAvailability } from '@/lib/ai/claude';
import { useFeatureFlag } from '@/lib/feature-flags/useFeatureFlag';
import { useQuery } from '@tanstack/react-query';
/**
 * Whether AI assistance may be used on a study. AI is opt-in per clinic, and
 * the clinic that counts is the STUDY'S: a teleconsultant has no membership
 * there, so the per-user `ai_assist` flag union cannot answer this for them.
 * Skips the request entirely while the region-wide `ai_agent` switch is off.
 */
export function useAiAvailability(studyId) {
    const aiAgentEnabled = useFeatureFlag('ai_agent');
    const query = useQuery({
        queryKey: ['ai-availability', studyId],
        queryFn: () => getAiAvailability(studyId),
        enabled: aiAgentEnabled && !!studyId,
        staleTime: 5 * 60 * 1000,
    });
    if (!aiAgentEnabled)
        return { availability: { available: false, reason: 'ai_disabled' }, isLoading: false };
    if (!studyId)
        return { availability: { available: false, reason: 'ai_not_enabled' }, isLoading: false };
    return { availability: query.data, isLoading: query.isLoading };
}
